import { setStatus, unassignDeviceModal } from '../unassignDeviceModalSlice';
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { DefaultTopLevelGroup } from '../../../common/constants';
import { fetchDeviceData } from '../../../pages/deviceManagement/deviceSlice';
import { isSuccessResponse } from '../../../common/utils';
import useNotification from '../../notification/useNotification';
import { IUpdateDevicePayload } from '../../../common/types/devicesTypes';

interface IProps {
    deviceId: string,
    deviceGroupId: string
}

export const useUnassignDeviceModal = (props: IProps) => {
    const { deviceId, deviceGroupId } = props;
    const dispatch: any = useDispatch();
    const [showModel, setShowModel] = useState(false);

    const handleClose = () => setShowModel(false);
    const handleShow = () => {
        setShowModel(true);
    };

    const { showSuccessNotification, showWarningNotification } = useNotification();

    const handleUnassignButtonClick = () => {
        const updateDevicePayload: IUpdateDevicePayload = {
            deviceId: deviceId,
            body: {
                organizationId: DefaultTopLevelGroup.ID,
                deviceGroupId: deviceGroupId
            }
        }

        dispatch(unassignDeviceModal(updateDevicePayload)).then((response)=>{
            if (isSuccessResponse(response.payload)) {
                dispatch(fetchDeviceData(''));
                dispatch(setStatus());
                showSuccessNotification(response.payload.message);
            }
            else {
                showWarningNotification(response.payload.response.data.message);
            }
        });
        setShowModel(false);
    };

    return {
        handleUnassignButtonClick,
        showModel,
        handleShow,
        handleClose
    };
}